import { render, staticRenderFns } from "./modalNovoAgente.vue?vue&type=template&id=19b6e5ad"
import script from "./modalNovoAgente.vue?vue&type=script&lang=js"
export * from "./modalNovoAgente.vue?vue&type=script&lang=js"
import style0 from "./modalNovoAgente.vue?vue&type=style&index=0&id=19b6e5ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports